import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import { NavLinkTab } from 'Shared';
import SuspenseSpinner from 'Utils/SuspenseSpinner';

const useStyles = createUseStyles({
  notificationsWrapper: {
    display: 'grid',
    gridTemplateRows: 'max-content 1fr',
    gridRowGap: '.5rem',
    padding: '.5rem',
    overflow: 'hidden',
  },
  content: {
    display: 'grid',
    overflow: 'auto',
  },
  tabs: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gridColumnGap: '.2rem',
  },
  tab: {
    fontSize: '.9rem',
  },
});

export function NotificationsWrapper() {
  const classes = useStyles();
  return (
    <div className={classes.notificationsWrapper}>
      <div className={classes.tabs}>
        <NavLinkTab className={classes.tab} to="current">Новые уведомления</NavLinkTab>
        <NavLinkTab className={classes.tab} to="archive">Все уведомления</NavLinkTab>
      </div>

      <div className={classes.content}>
        <Suspense fallback={<SuspenseSpinner />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
}
